import { Component, inject, output } from '@angular/core';
import { Paginator, PaginatorState } from 'primeng/paginator';
import { TranslatePipe } from '@ngx-translate/core';
import { PaginationService } from '#services';

@Component({
  selector: 'app-paginator',
  imports: [Paginator, TranslatePipe],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss',
})
export class PaginatorComponent {
  private _paginationService = inject(PaginationService);

  currentPage = this._paginationService.currentPage;
  pageSize = this._paginationService.pageSize;
  totalCount = this._paginationService.totalCount;
  currentRange = this._paginationService.currentRange;

  pageChanged = output<PaginatorState>();

  onPageChange(state: PaginatorState) {
    const { page, first } = state;
    this._paginationService.setPageNumber(page! + 1, first!);
    this.pageChanged.emit(state);
  }
}
